$(document).on('turbo:load', function() {
  initializeListeners();

  $(document).on('click', '#sorts-direction-desc', function(){
    $('#sorts-direction-asc').removeClass('d-none');
    $('#sorts-direction-desc').addClass('d-none');
    $('#q_sorts_direction').val('asc');
    Rails.fire($('#subscription_search')[0], 'submit');
  });

  $(document).on('click', '#sorts-direction-asc', function(){
    $('#sorts-direction-desc').removeClass('d-none');
    $('#sorts-direction-asc').addClass('d-none');
    $('#q_sorts_direction').val('desc');
    Rails.fire($('#subscription_search')[0], 'submit');
  });
});

function handleSubscriptionModalOpen(event) {
  const newSubscriptionForm = document.getElementById('newSubscriptionForm');

  if (!newSubscriptionForm.checkValidity()) {
    newSubscriptionForm.reportValidity();

    event.stopPropagation();
    event.preventDefault();
  } else {
    const amountInput = document.getElementById('subscription_amount');
    const availableBalanceContainer = amountInput?.closest('[data-available-balance]');

    const requestedAmount = parseInt(amountInput?.value);
    const availableBalance = parseInt(availableBalanceContainer?.dataset.availableBalance);

    if (
      requestedAmount &&
      availableBalance &&
      requestedAmount > availableBalance
    ) {
      event.stopPropagation();
      event.preventDefault();

      $('#notEnoughMoneyOnWalletModal').modal('show');
      return;
    }

    const submitButton = document.getElementById('investBtn');

    if (submitButton.dataset['sponsorshipAppliedMessage']) {
      toastr.success(submitButton.dataset['sponsorshipAppliedMessage']);
    } else if (document.getElementById('subscription_bonus_code_text')?.value) {
      toastr.success(submitButton.dataset['bonusAppliedMessage']);
    }
  }
}

function update_subscription_confirm_modal(amount) {
  var amountConfirm = $(this).val();
  var formattedAmount = new Intl.NumberFormat(
    'fr-FR',
    { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }
  ).format(amountConfirm);

  $('#confirmSubscriptionModal')?.find('#subscribedAmount')?.html(formattedAmount);
}

function initializeListeners() {
  let subscriptionModal = $('#confirmSubscriptionModal');

  if (subscriptionModal.length <= 0) {
    return;
  }

  subscriptionModal.on('show.bs.modal', handleSubscriptionModalOpen);

  update_subscription_confirm_modal.call($('#subscription_amount'));
  $('#subscription_amount').bind('change', update_subscription_confirm_modal);

  $(document).on('keydown', '#newSubscriptionForm', function(event) {
    if (event.keyCode == 13) {
      event.preventDefault();
      if (subscriptionModal.length > 0) {
        const submitButton = document.getElementById('investBtn');

        if (!submitButton?.disabled) {
          update_subscription_confirm_modal.call($('#subscription_amount'));
          subscriptionModal.modal('show');
        }
      } else {
        $('#simulateButton').click();
      }
      return;
    }
  });
}

// Expose top-level declarations as globals (pre-bundler concatenation behavior).
window.initializeListeners = initializeListeners;
